import { useState, useEffect } from 'react';
import { Menu } from 'lucide-react'; // ✅ Add this
import Sidebar from './Sidebar';
import Header from './Header';

export default function LayoutWithSidebar({ children }) {
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [showMobileSidebar, setShowMobileSidebar] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const savedTheme = localStorage.getItem('snapyora-theme');
    if (savedTheme === 'dark') setDarkMode(true);
  }, []);

  useEffect(() => {
    localStorage.setItem('snapyora-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  return (
    <div className={`${darkMode ? 'dark' : ''}`}>
      <div className="flex h-screen bg-white dark:bg-gray-900">
        {!showMobileSidebar && (
          <button
            onClick={() => setShowMobileSidebar(true)}
            className="md:hidden fixed top-4 left-4 z-50 p-2 bg-indigo-600 text-white rounded-md"
          >
            <Menu size={20} /> {/* ✅ Replace broken Sidebar.ToggleIcon */}
          </button>
        )}

        <Sidebar
          isSidebarOpen={isSidebarOpen}
          setSidebarOpen={setSidebarOpen}
          showMobileSidebar={showMobileSidebar}
          setShowMobileSidebar={setShowMobileSidebar}
        />

        <div className="flex-1 flex flex-col transition-all duration-300">
          <Header
            darkMode={darkMode}
            setDarkMode={setDarkMode}
            showMobileSidebar={showMobileSidebar}
          />

          <main className="p-4 overflow-y-auto bg-gray-50 dark:bg-gray-900 flex-1 text-gray-900 dark:text-white">
            {children}
          </main>
          <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 px-4 py-3 text-center text-xs text-gray-500 dark:text-gray-400">
            © {currentYear} Powered by Bagavaan Groups | ATA Services
          </footer>
        </div>
      </div>
    </div>
  );
}